import type { Partner } from '@/data'
import type { PaginatedResponse, ListParams } from '@/api/client'
import { buildQuery } from '@/api/client'
import api from '..'

export type PaginatedPartners = PaginatedResponse<Partner>

export async function getPartners(
  params?: ListParams,
): Promise<PaginatedPartners> {
  const res = await api.get('/partners', { params: buildQuery(params) })
  return { data: res.data.data, meta: res.data.meta }
}
